import { useState, useContext } from 'react';

import '../CompaniesPage/CompaniesPage.css';
import { FinancialBuilderContext } from '../FinancialBuilderPage.jsx';

import { renderFormRow, genericPOSTDatabaseCall } from '../../helperFunctions.jsx';
import { costAllocationsRenderFields, industryDetails } from '../../constants.jsx';

async function saveCompanyToDatabase(company) {
    return genericPOSTDatabaseCall('/api/fb/saveCompanyInfo', { company }, 'company info');
}

function CostAllocations({ contextToUse }) {
    const { companySelected, messageApi, setCompanySelected } = useContext(contextToUse || FinancialBuilderContext);
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        setSaving(true);
        messageApi.loading('Saving company info...', 0);
        try {
            await saveCompanyToDatabase({ ...companySelected, id: companySelected.fb_id !== undefined ? companySelected.fb_id : companySelected.id });
            messageApi.destroy();
            messageApi.success('Company info saved successfully');
        } catch (error) {
            console.error('Error saving company info:', error);
            messageApi.destroy();
            messageApi.error('Failed to save company info');
        }
        setSaving(false);
    };

    const handleInputChange = (event, company, key, field) => {
        let newValue = event.target.value;

        setCompanySelected(prev => ({
            ...prev,
            [key]: newValue
        }));
    }

    const handleInputBlur = (event, company, key, field) => {
        let newValue = event.target.value;

        if (field.regexCondition && field.errorMessage && !field.regexCondition.test(newValue)) {
            messageApi.error(field.errorMessage);
            newValue = industryDetails[company.industry] ? industryDetails[company.industry][key] : field.default || ''; // Use default value if provided
        }

        if (newValue === '') {
            messageApi.error('This field cannot be empty');
            newValue = industryDetails[company.industry] ? industryDetails[company.industry][key] : field.default || ''; // Use default value if provided
        }

        setCompanySelected(prev => ({
            ...prev,
            [key]: newValue
        }));
    }

    return (
        <div className="other-variables-cost financial-builder-container entity-industry-container">
            <h2>Cost Allocations</h2>
            <div className='entity-card'>
                {costAllocationsRenderFields.map(field => renderFormRow(field, companySelected, handleInputChange, true, handleInputBlur))}
                <div className="flex-row bottom-actions">
                    <div className="form-row actions-row">
                        <button disabled={saving} type="button" className="save-button" onClick={handleSave}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CostAllocations;